import type { PublisherHashmap } from '../types/publisher';
import { loadHashmap as loadPublisherHashmap } from '../modules/publisher'
import { slotKeyToSlotId, getDeviceType, getPageType, log, logError } from './utilities'
import { deviceType } from './enums';

export const EVENTS = {
	SLOT_MARGIN_UPDATED: 'mega.slot.idealMargins.updated'
}

let _hashmap: PublisherHashmap | null = null;
let _hashmapQueue: string[] = [];
let _hashmapVersion: number = 0;

// export let idealMargins:{[key: string]: string } = {} // json here

// let idealMarginsQueue: Function[] = [] // callback functions to set the margins again

export function getHashMapVersion() {
	return _hashmapVersion;
}

export async function initIdealMargins() {
    try {
        const hashmap = await loadPublisherHashmap(5);
		if(hashmap) {
        	_hashmap = hashmap.data;
			_hashmapVersion = hashmap.version;
		}
		log('---- MEGA PUBLISHER HASHMAP LOADED ----')
    } catch (error) {
        logError('---- MEGA ERROR LOADING PUBLISHER HASHMAP ----', error)
    }

    if(_hashmap === null)
        return;

    // Process queue
    if(_hashmapQueue.length) {
        log('Processing hashmap queue')

		if(!window?._mega?.publisher?.slots) {
			logError('Publisher slots not found');
			return;
		}

		let slotMap: {[key: string]: Slot} = {};
		slotMap = Object.assign(slotMap, window?._mega?.publisher?.slots);
		const allSlots: Slot[] = Object.values(slotMap);

        for(let i = 0; i < _hashmapQueue.length; i++) {
            const id = _hashmapQueue[i];
            log('Processing hashmap for slot', id)
			//TODO 

			const slot = allSlots.find((slot) => slot.id && slot.id === id)

			if(!slot) {
				logError('Slot not found', id)
				continue;
			}

			if(!slot._el) {
				logError('Slot element not found', id)
				continue;
			}
			
			slot._el.dispatchEvent(new CustomEvent(EVENTS.SLOT_MARGIN_UPDATED));
        }
    }
    // console.log('qqqq hashmap', _hashmap)
}


// export function setIdealMargins(json:{[key: string]: string }) {
//     idealMargins = json
// }

// export function addQueue(func: Function) {
//     idealMarginsQueue.push(func)
// }

// export function runQueue() {
//     idealMarginsQueue.forEach((func) => func())
//     idealMarginsQueue = []
// }


// export function hasIdealMargin(slot:Slot):boolean {
//     if (!Object.entries(idealMargins).length) return false

//     return idealMargins[idealMarginHashmapName(slot.id)] ? true : false
// }

// export function getIdealMargin(slot:Slot): number | false {
//     if (!Object.entries(idealMargins).length) return false

//     return parseInt(idealMargins[idealMarginHashmapName(slot.id)]) ?? false
// }

export function getIdealMargin(slot: Slot) {
    log('Get ideal margin for slot', slot.id)

    if(_hashmap === null) {
        log('Hashmap not ready yet, adding to queue', slot.id)
        // Add to queue
        _hashmapQueue.push(slot.id);
        return null;
    }

    const hashmapName = idealMarginHashmapName(slot.id);

    const hashmapMargin = _hashmap[hashmapName] ?? null;

    if(!hashmapMargin)
        return null;

    let idealMargin = hashmapMargin;
    if(typeof idealMargin !== 'number') {
        idealMargin = parseInt(idealMargin);
    }

    if(isNaN(idealMargin))
        return null;

	log('Ideal margin for slot found at', hashmapName)

    return idealMargin;
}


export function idealMarginHashmapName(slotKey:string): string {
	let mapname = ''
	
	const device = getDeviceType() ?? deviceType.DESKTOP
	mapname += device.charAt(0);

	let slotId = slotKey.startsWith('ada-') ? slotKey : slotKeyToSlotId(slotKey)

	mapname += '_'
	mapname += getPageType() + '/' + slotId
	mapname += '_'
	// let currentDate = new Date()
	
	// let dayname = ["su","mo","tu","we","th","fr","sa"][currentDate.getDay()]

	/* 
		if dayname should beweekend/weekday (to make the json smaller), this should be the code:
		let dayname = [0,6].includes(currentDate.getDay()) ? 'weekend' : 'weekday'
	*/

	// mapname += dayname
	// mapname += '_'

	const ua = navigator.userAgent;
	mapname += /android/i.test(ua) ? 'a' : /iPad|iPhone|iPod/.test(ua) ? 'i' : 'o';
	
	//mapname += currentDate.getHours() > 8 && currentDate.getHours() < 18 ? 'workinghours' : 'nonworkinghours'

	return mapname
}
